import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Button } from 'reactstrap';
import config from '../../config';

import './MemberOnly.scss';

const MemberOnly = ({ i18n }) => {
  const { translations = {}, locale } = i18n || {};
  const { header_bar = {}, memberOnly = {} } = translations[locale] || {};
  const { description = '' } = memberOnly;
  const { title_login = '', title_register = '' } = header_bar;

  const _getSSOLangCode = () => {
    return config.sso_lang_map[locale];
  };

  const handleLoginClick = (e) => {
    e.preventDefault();
    if (window.ssoClient) {
      window.ssoClient.login({
        lang: _getSSOLangCode(),
        redirect_uri: window.location.href,
      });
    }
  };

  const handleRegisterClick = (e) => {
    e.preventDefault();
    if (window.ssoClient) {
      window.ssoClient.register({
        lang: _getSSOLangCode(),
        redirect_uri: window.location.href,
      });
    }
  };

  return (
    <Container className="memberOnly">
      <Row>
        <Col className="text-center">
          {description}
          <div className="memberOnly__buttons">
            <Button color="primary" onClick={() => handleLoginClick()}>
              {title_login}
            </Button>
            <Button color="primary" onClick={() => handleRegisterClick()}>
              {title_register}
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(MemberOnly);

export { MemberOnly as MemberOnlyComponent }; // <- For component Unit Test
export default connectStore;
